module.exports = flarum.core.compat['utils/mixin'];